import HCLTreeVertexValue from '../../HCLTreeVertexValue/HCLTreeVertexValue';
import { Formula, FormulaJSON } from '../../HCLTreeVertexValue/Formula';
import ProxyType from '../../HCLTreeVertexValue/ProxyTypes';
import { Label, LabelJSON } from '../../HCLTreeVertexValue/Label';
import { OutcomeJSON } from '../../HCLTreeVertexValue/Outcome';

interface GateVertexValueJSON {
  label: LabelJSON;
  formula: FormulaJSON | OutcomeJSON;
}

abstract class GateVertexValue extends HCLTreeVertexValue {
  protected formula: Formula;

  /**
   * @param {Label} label
   * @param {Formula} formula
   */
  protected constructor(label?: Label, formula?: Formula) {
    super(label);
    this.formula = formula || this.getDefaultFormula();
  }

  /**
   * @returns {Formula}
   */
  getFormula(): Formula {
    return this.formula;
  }

  public getDefaultFormula(): Formula {
    return new Formula({ _proxy: ProxyType.LOGICAL_EXPRESSION });
  }

  public getDefaultLabel(): Label {
    return new Label('Gate', '');
  }

  /**
   * @param {Formula} formula
   */
  setFormula(formula: Formula) {
    this.formula = formula;
  }

  /**
   * @returns {Object<String, *>} - dictionary object that describes this
   */
  toJSON(): GateVertexValueJSON {
    return ({
      ...super.toJSON(),
      formula: this.formula.toJSON(),
    });
  }
}

export default GateVertexValue;
export { GateVertexValue, GateVertexValueJSON };
